<template>
    <aside class="sidebar" v-if="!this.$root.sidebarHidden">
        <slot></slot>
    </aside>
</template>

<script>
export default {
    created: function() {
        if (window.innerWidth >= 1200) this.$root.sidebarHidden = false;
    }
};
</script>
